<h1>Créer un nouvel article</h1>

<div class="container mb-5">
    <form class="article-form" [formGroup]="articleForm" (ngSubmit)="onSubmitForm()">

        <div class="mb-3">
            <label for="titleArticle" class="form-label">Titre de l'article</label>
            <input type="text" class="form-control" id="titleArticle" aria-describedby="titleHelp" formControlName="title" (blur)="testTitle()">
            <div class="text-danger">{{ messageErrorTitle }}</div>
        </div>
        
        <div class="mb-3">
            <label for="formFile" class="form-label">L'image pour illustrer l'article</label>
            <input class="form-control" type="file" id="formFile" formControlName="pathImg" (focus)="onUnuploadFile()" (change)="detectFiles($event)">
            <div id="ImgHelp" class="form-text">Il faut charger des images en format <a href="https://www.iloveimg.com/fr/editeur-de-photos" class="link-dark" target="_blank">4:3</a></div>
            <div *ngIf="fileIsUploading" class="spinner-border text-success" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <div *ngIf="fileUploaded" class="text-success">Image chargée !</div>
        </div>

        <div class="mb-3">
            <label for="introArticle" class="form-label">Une introduction de l'article</label>
            <input type="text" class="form-control" id="introArticle" aria-describedby="introHelp" formControlName="intro" (blur)="testIntro()">
            <div class="text-danger">{{ messageErrorIntro }}</div>
        </div>

        <div class="mb-3">
            <label for="exampleFormControlTextarea" class="form-label">Le contenu de l'article</label>
            <textarea class="form-control" id="exampleFormControlTextarea" rows="10" formControlName="content"></textarea>
        </div>

        <button type="submit" class="btn" [disabled]="articleForm.invalid || !fileUploaded">Poster l'article</button>
        <div>fileUpdate: {{ fileUploaded }} / articleForm{{ !articleForm.invalid }}</div>
    </form>
</div>
